module.exports = __webpack_public_path__ + "img/live.e5661b5.svg";